/**
 * Simple fuzzy search utilities for question text and answers
 */

/** Simple fuzzy match: all query words must appear in the text (case-insensitive) */
export const fuzzyMatch = (query: string, text: string): boolean => {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  const lower = text.toLowerCase();
  return words.every((w) => lower.includes(w));
};

/** Score a fuzzy match (higher = better). Returns 0 if no match. */
export const fuzzyScore = (query: string, text: string): number => {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  const lower = text.toLowerCase();
  if (!words.every((w) => lower.includes(w))) return 0;
  // Bonus for exact substring match
  let score = words.length;
  if (lower.includes(query.toLowerCase())) score += 10;
  // Bonus for match appearing early
  const firstIdx = Math.min(...words.map((w) => lower.indexOf(w)));
  score += Math.max(0, 100 - firstIdx) / 100;
  return score;
};
